<div class="mx-4">
  <div class="row row-cols-1 row-cols-lg-2 mb-3">
  
    <div class="col mb-3">
      <div class="card h-100 alert-primary">
        <div
          class="card-img-top"
          [ngStyle]="{'background-image': 'url(/assets/images/stock/poodle-boxer.jpg)'}">
        </div>
        <div class="card-body">
          <h6 class="card-title mt-0">
            <strong>Help Centre</strong>
          </h6>
          <p class="mb-1">
            Have a question or a little unsure what to do? Click on our Help Centre for support and guidance.
          </p>
        </div>
        <div class="card-footer">
          <a
            href="https://identicare.zendesk.com/hc/en-us"
            class="btn btn-primary text-white w-100"
            target="_blank">
            Help centre
          </a>
        </div>
      </div>
    </div>
  
    <div class="w-100 d-none d-sm-block d-lg-none">
      &nbsp;
    </div>
  
    <div class="col mb-3">
      <div class="card h-100 alert-secondary">
        <form
          #chipCheckerForm="ngForm"
          (ngSubmit)="checkChip()"
          novalidate>
          <div
            class="card-img-top"
            [ngStyle]="{'background-image': 'url(/assets/images/stock/cat-sleeping.jpg)'}">
          </div>
          <div class="card-body">
            <h6 class="card-title mt-0">
              <strong>Chip Checker</strong>
            </h6>
            <p class="mb-3">
              Enter your microchip number to check which UK database holds your details.
            </p>
            <div *ngIf="chipCheckerResults" class="text-center">
              <p [class]="'text-' + chipCheckerResults.type">{{ chipCheckerResults.message }}</p>
              <p *ngIf="chipCheckerResults.type === 'success'">
                <a *ngFor="let link of chipCheckerResults.links; let last=last" href="{{ link }}" target="_blank">{{ link }}<span *ngIf="!last">, </span></a>
              </p>
            </div>
            <div class="form-check">
              <input
                #checkChipAgree="ngModel"
                type="checkbox"
                class="form-check-input"
                id="checkChipAgree"
                name="checkChipAgree"
                ngModel=""
                required>
              <label class="form-check-label" for="checkChipAgree">
                <span class="small fw-bold">
                  By using this lookup you consent to identibase storing your IP address, which identibase will use for pet reuniting
                  purposes. Please tick this box to indicate your agreement to us using your IP address for these purposes.
                </span>
              </label>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12">
                <input
                  #checkChipNumber="ngModel"
                  type="text"
                  class="form-control"
                  placeholder="Chip number"
                  id="checkChipNumber"
                  name="checkChipNumber"
                  [(ngModel)]="chipCheckerNumber"
                  [disabled]="chipCheckerLoading"
                  required>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button
              type="submit"
              class="btn btn-secondary text-white w-100"
              [disabled]="!chipCheckerForm.valid || chipCheckerLoading">
              <fa-icon *ngIf="chipCheckerLoading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
              {{ chipCheckerLoading ? 'Checking...' : 'Check Chip' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  
  </div>
</div>
